module.exports = __webpack_public_path__ + "static/media/div1.664e2f85.jpg";